// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__2n36e","oops":"style_oops__24BC9","message":"style_message__2Mdw9"};